import React from "react";
import Layout from "../components/layout/MainLayout";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { graphql } from "gatsby";
import Theme, { titleCase } from "../vars/ThemeOptions";
import { Snapshot } from "../components/modules/";
import PrevNext from "../components/layout/TopicPrevNext/TopicPrevNext";
import { SEO } from "wmk-lib";
import RichText from "../richText/RichText";
import { Accordion, Backlink, Intro, P, H3 } from "../components/common";
const Styled = {};

const TopicModules = {
  // ContentfulModuleBodyCopy: () => <BodyCopy />,
  ContentfulModuleSnapshot: ({ module }) => <Snapshot module={module} />,
  ContentfulModuleBodyCopy: ({ module }) => {
    const { hideTitle, title, bodyCopy, showAsAccordion } = module;
    const { json } = bodyCopy ? bodyCopy : { json: null };
    return showAsAccordion ? (
      <TypeAccordionText title={title} json={json} />
    ) : (
      <TypeNormalText hideTitle={hideTitle} title={title} json={json} />
    );
  },
};

Styled.Accordion = styled(Container)`
  position: relative;
  button.btn {
    h3 {
      margin: auto;
    }
    width: 100%;
    margin: 0;
    color: ${Theme.hex("black")};
    text-decoration: none;
    :hover {
      text-decoration: none;
      color: ${Theme.hex("blue")};
    }
    @media screen {
      :focus {
        outline: none;
        box-shadow: none;
      }
    }
  }
  .accordion {
    padding: 0;
  }
  .plus {
    font-size: 2rem;
    position: absolute;
    left: 80%;
    top: -2%;
  }
`;

const TypeAccordionText = ({ title, json }) => {
  return (
    <Container>
      <Row className="flex-column">
        <Accordion title={title} json={json} />
      </Row>
    </Container>
  );
};

const TypeNormalText = ({ hideTitle, title, json }) => {
  return (
    <Row className="flex-column">
      {!hideTitle && (
        <Col xs={{ span: 10, offset: 1 }}>
          <H3 topic style={{ paddingLeft: "1rem" }}>
            {title}
          </H3>
        </Col>
      )}
      {json && (
        <Col xs={{ span: 10, offset: 1 }} style={{ margin: "auto" }}>
          <P left fluid>
            <RichText json={json} />
          </P>
        </Col>
      )}
    </Row>
  );
};

Styled.FlexibleContent = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0;
  a {
    margin: 1rem 0 0.5rem 0;
    color: ${Theme.hex("green")};
  }
  h2 {
    margin-bottom: 1rem;
  }
  .flex-column {
    padding: 0 0 4vh 0;
  }
`;

export default ({ data }) => {
  //console.log(data);
  const { topic, chapters } = data;
  const { slug, ogImage, twitterImage } = topic;
  const _topic = { ...topic };
  const _chapter = topic.chapter.toLowerCase();
  _topic["chapter"] = _chapter;
  const { modules, longImage } = _topic;

  const currChapter = topic.chapter.toLowerCase();
  let currChapterTopics;
  chapters.edges.map((chapter) => {
    return chapter.node.slug === currChapter
      ? (currChapterTopics = chapter.node.topics)
      : null;
  });
  // console.log("currChapterTopics: ",currChapterTopics);

  return (
    <Layout pageType={"topics"} slug={slug} parentChapter={_chapter}>
      <SEO.Meta
        title={_topic.title}
        slug={slug}
        baseUrl={Theme.paths.protocol + "://" + Theme.paths.baseUrl}
        siteTitle={"Texas Health"}
        ogImage={
          ogImage && ogImage.fixed && ogImage.fixed.src
            ? "https:"+ogImage.fixed.src
            : undefined
        }
        twitterImage={
          twitterImage && twitterImage.fixed && twitterImage.fixed.src
            ? "https:"+twitterImage.fixed.src
            : undefined
        }
        twitterHandle={"@texashealth"}
      />
      <Container fluid>
        <Intro
          subtitle={_topic.subhead}
          title={_topic.title}
          json={_topic.subText.json}
          backlink={_chapter}
          left
          mainImage={longImage}
        />
      </Container>
      <Styled.FlexibleContent fluid>
        {modules &&
          modules.map((module, i) => {
            const { __typename } = module;
            const JSX = TopicModules[__typename];
            return JSX ? (
              <JSX module={module} key={"module" + i} />
            ) : (
              <strong key={"module" + i}>
                No markup found for the {__typename} module
              </strong>
            );
          })}
      </Styled.FlexibleContent>
      <PrevNext
        currTopic={topic.title}
        topics={currChapterTopics}
        currChapter={currChapter}
      />
      <Container>
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1vh 0 1.5vh 0",
            }}
          >
            <Backlink to={"/" + _chapter}>
              Back to {titleCase(_chapter)}
            </Backlink>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query topicQuery($slug: String!) {
    topic: contentfulTopics(slug: { eq: $slug }) {
      ...NodeTopicsFields
      ogImage: mainImage {
        fixed(width: 1200, height: 630, quality: 80, cropFocus: FACE) {
          ...GatsbyContentfulFixed_withWebp_noBase64
        }
      }
      twitterImage: mainImage {
        fixed(width: 876, height: 438, quality: 80, cropFocus: FACE) {
          ...GatsbyContentfulFixed_withWebp_noBase64
        }
      }
    }
    chapters: allContentfulChapters {
      edges {
        node {
          slug
          title
          topics {
            title
            slug
            chapter
          }
        }
      }
    }
  }
`;
